

import { useLoggedGeladaMutation } from '@netfront/gelada-identity-library';

import { CREATE_SMART_CODE } from './useCreateSmartCode.graphql';
import {
  IUseCreateSmartCode,
  ICreateSmartCodeMutationGraphQLResponse,
  IUseCreateSmartCodeOptions,
  ICreateSmartCodeMutationVariables,
  IHandleCreateSmartCodeParams,
} from './useCreateSmartCode.interfaces';

const useCreateSmartCode = (options?: IUseCreateSmartCodeOptions): IUseCreateSmartCode => {
  const { mutation, onCompleted, onError, product, tokens } = options ?? ({} as IUseCreateSmartCodeOptions);

  const [executeCreateSmartCode, { loading: isLoading }] = useLoggedGeladaMutation<
    ICreateSmartCodeMutationGraphQLResponse,
    ICreateSmartCodeMutationVariables
  >({
    mutation: mutation ?? CREATE_SMART_CODE,
    options: {
      onCompleted: ({
        smartCode: {
          add: smartCode,
        },
      }) => {
        if (!onCompleted) {
          return;
        }

        onCompleted({
          smartCode,
        });
      },
      onError,
    },
    product,
    tokens,
  });

  const handleCreateSmartCode = async ({
    projectId,
    code,
    groups,
  }: IHandleCreateSmartCodeParams) => {
    await executeCreateSmartCode({
      variables: {
        projectId,
        code,
        groups,
      },
    });
  };

  return {
    handleCreateSmartCode,
    isLoading,
  };
};

export { useCreateSmartCode };
